import { render, staticRenderFns } from "./BaseFooter.vue?vue&type=template&id=37c1c8c7&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BaseFooter.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Ffooter%2FBaseFooter%2FBaseFooter.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports